import { render, staticRenderFns } from "./FTtransactionDetailModal.vue?vue&type=template&id=458cb734&scoped=true&"
import script from "./FTtransactionDetailModal.vue?vue&type=script&lang=js&"
export * from "./FTtransactionDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./FTtransactionDetailModal.vue?vue&type=style&index=0&id=458cb734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458cb734",
  null
  
)

export default component.exports